import axios from "axios";
import { createHeaders, createHeadersAdmin } from "../../utils/Utils";
import { BASE_URL } from "../../assets/constants/constants";
//! dashboard
//  Dashboard
export const createVideoAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}add-video`, data,headers);
};
// Sidebar
export const updateVideoAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}update-video`, data,headers);
};
// Sidebar
export const getVideoListAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}get-video-list`, data,headers);
};
// Sidebar
export const videoStatusUpdateAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}update-video-status`, data,headers);
};